import { questionFilterParam } from "./questionsFilterParam.js";

export function toReportFilterUrl<T>(request: { base: URL; state: T }): URL {
  const url = new URL(request.base.toString());
  url.searchParams.set(questionFilterParam, JSON.stringify(request.state));
  return url;
}
